<!-- <dx-scroll-view> -->


    <div class="full-page" style="margin: 30px; ">
        <dx-box direction="col" class="full-height-box" style="margin-bottom: 50px;">
            <dxi-item [ratio]="1">
                <dx-box direction="row">
                    <dxi-item [ratio]="1">
                        <dx-box direction="col" [height]="80">
                            <dxi-item [ratio]="1">
                                <dx-box direction="row">
                                    <dxi-item [ratio]="1">
                                        <h1>{{data?.companyName}}</h1>
                                    </dxi-item>
                                    <dxi-item [ratio]="1">
                                        <div>{{data?.status}} </div>
                                    </dxi-item>
                                </dx-box>
                            </dxi-item>
                            <dxi-item [ratio]="1">
                                <dx-box direction="row">
                                    <dxi-item [ratio]="2">
                                        ID: {{data?.id}}, Reg. Number: {{data?.registrationNumber}}
                                    </dxi-item>
                                </dx-box>
                            </dxi-item>
                        </dx-box>
                    </dxi-item>
                    <dxi-item [ratio]="1">

                        <dx-box direction="row">
                            <dxi-item [ratio]="1">
                                <app-approve [merchantId]="merchantId">
                                </app-approve>
                            </dxi-item>
                            <dxi-item [ratio]="1">
                                <app-request-additional-info [merchantId]="merchantId">
                                </app-request-additional-info>
                            </dxi-item>
                            <dxi-item [ratio]="1">
                                <app-decline [merchantId]="merchantId">
                                </app-decline>
                            </dxi-item>
                        </dx-box>

                        <div>

                        </div>
                    </dxi-item>
                </dx-box>
            </dxi-item>

            <dxi-item [ratio]="1">
                <h1> Merchant info</h1>
            </dxi-item>

            <dxi-item [ratio]="1">


                <dx-box direction="row" width="70%">

                    <dxi-item [ratio]="1">
                        <dx-button text="Select" [width]="150">
                        </dx-button>
                    </dxi-item>
                    <dxi-item [ratio]="3">
                        <div>
                            Super Merchant - Edit
                        </div>
                        <div>
                            Cape Crafters Approved
                        </div>
                        <div>
                            Merchant, ID: 234234324, Reg. Number 2423423423
                        </div>
                    </dxi-item>
                </dx-box>

            </dxi-item>

            <dxi-item [ratio]="1">
                <dx-box direction="row">
                    <dxi-item [ratio]="1">
                        <div>
                            Address: edit
                        </div>
                        <div *ngFor="let item of data?.merchantAddresses">
                            {{item.numberAndStreet}}
                            {{item.city}}
                            {{item.code}}
                            {{item.country}}
                            {{item.status}}
                        </div>
                    </dxi-item>
                    <dxi-item [ratio]="1">
                        <dx-box direction="col" [height]="400">
                            <dxi-item [ratio]="1">
                                Contact: edit
                            </dxi-item>
                            <dxi-item [ratio]="5">
                                <dx-box direction="col" [height]="200">
                                    <dxi-item [ratio]="1">
                                        <dx-box direction="row" width="100%">
                                            <dxi-item [ratio]="1">
                                                <dx-box direction="col" [height]="100">
                                                    <dxi-item [ratio]="1">
                                                        <dx-box direction="row" width="100%">
                                                            <dxi-item [ratio]="1">
                                                                Contact person:
                                                            </dxi-item>
                                                            <dxi-item [ratio]="1">
                                                                {{data?.merchantContacts[0].contactName}}
                                                            </dxi-item>
                                                        </dx-box>
                                                    </dxi-item>
                                                    <dxi-item [ratio]="1">
                                                        <dx-box direction="row" width="100%">
                                                            <dxi-item [ratio]="1">
                                                                Phone
                                                            </dxi-item>
                                                            <dxi-item [ratio]="1">
                                                                {{data?.merchantContacts[0].contactPhone}}
                                                            </dxi-item>
                                                        </dx-box>
                                                    </dxi-item>
                                                    <dxi-item [ratio]="1">
                                                        <dx-box direction="row" width="100%">
                                                            <dxi-item [ratio]="1">
                                                                Email
                                                            </dxi-item>
                                                            <dxi-item [ratio]="1">
                                                                {{data?.merchantContacts[0].contactEmail}}
                                                            </dxi-item>
                                                        </dx-box>
                                                    </dxi-item>

                                                    <dxi-item [ratio]="1">
                                                        <dx-box direction="row" width="100%">
                                                            <dxi-item [ratio]="1">
                                                                Statement delivery
                                                            </dxi-item>
                                                            <dxi-item [ratio]="1">
                                                                <div>
                                                                    emleml.com
                                                                </div>
                                                            </dxi-item>
                                                        </dx-box>
                                                    </dxi-item>
                                                </dx-box>
                                            </dxi-item>
                                        </dx-box>
                                    </dxi-item>
                                </dx-box>
                            </dxi-item>
                        </dx-box>
                    </dxi-item>
                </dx-box>
            </dxi-item>

            <dxi-item [ratio]="1" style="margin-top: 20px">
                <app-document-grid [merchantId]="merchantId"></app-document-grid>
            </dxi-item>
        </dx-box>
    </div>

<!-- </dx-scroll-view> -->
<form-popup [(visible)]="isSelectSuperMerchantPopupOpened" titleText="Select super merchant">
</form-popup>